module.exports = __webpack_public_path__ + "static/profile-pic-b53e0cc065a621859eb7f91f1433303d.jpg";